export const translations = {
  de: {
    nav: {
      about: 'Über mich',
      services: 'Services',
      skills: 'Tech Stack',
      experience: 'Erfahrung',
      projects: 'Projekte',
      contact: 'Kontakt'
    },
    hero: {
      greeting: 'Hallo, ich bin',
      name: 'Patrizio Sbardella',
      title: 'IT Consultant & Solutions Architect',
      subtitle: 'Von komplexen Datenanalysen bis zur Web-Entwicklung – ich löse IT-Herausforderungen ganzheitlich',
      description: 'Spezialisiert auf Data Analytics, Business Intelligence, Web Development und strategische IT-Lösungen im Gesundheitswesen und darüber hinaus.',
      cta: 'Projekt besprechen',
      viewWork: 'Projekte ansehen'
    },
    about: {
      title: 'Über mich',
      subtitle: 'IT-Experte mit Weitblick',
      intro: 'Als vielseitiger IT Consultant verbinde ich technische Expertise mit strategischem Denken. Meine Stärke liegt darin, komplexe IT-Herausforderungen zu analysieren und maßgeschneiderte Lösungen zu entwickeln.',
      approach: 'Ob Datenanalyse, Web-Entwicklung oder IT-Infrastruktur – ich bringe über 20 Jahre Erfahrung in verschiedenen IT-Bereichen mit und finde für jedes Problem die optimale technische Lösung.',
      expertise: 'Von der Entwicklung interaktiver Dashboards über die Programmierung von Web-Anwendungen bis zur strategischen IT-Beratung – meine Expertise deckt das gesamte Spektrum moderner IT-Lösungen ab.'
    },
    services: {
      title: 'Services',
      subtitle: 'Ganzheitliche IT-Lösungen',
      data: {
        title: 'Data Analytics & BI',
        desc: 'Entwicklung von BI-Lösungen, interaktiven Dashboards und datengesteuerten Analysen mit Power BI, PostgreSQL, Metabase und Apache Airflow.',
        items: ['Power BI Dashboards', 'Data Warehouse Design', 'ETL Prozesse', 'Business Intelligence', 'Predictive Analytics', 'Data Storytelling']
      },
      web: {
        title: 'Web Development',
        desc: 'Fullstack-Entwicklung moderner Web-Anwendungen mit React, Node.js, Python und modernen Frameworks.',
        items: ['React & JavaScript', 'Python/FastAPI', 'Responsive Design', 'CMS (Typo3)', 'REST APIs', 'Database Design']
      },
      consulting: {
        title: 'IT Consulting',
        desc: 'Strategische IT-Beratung, Prozessoptimierung und Lösungsarchitektur für komplexe technische Herausforderungen.',
        items: ['IT Strategie', 'Prozessautomatisierung', 'System Integration', 'Technical Leadership', 'Healthcare IT', 'Project Management']
      }
    },
    techStack: {
      title: 'Tech Stack',
      subtitle: 'Technologien & Tools',
      categories: {
        data: 'Data & Analytics',
        web: 'Web Development',
        database: 'Datenbanken',
        tools: 'Tools & Platforms',
        languages: 'Programmiersprachen'
      }
    },
    experience: {
      title: 'Berufserfahrung',
      subtitle: 'Über 20 Jahre IT-Expertise',
      present: 'Heute',
      roles: {
        gfo: {
          title: 'Software-Berater',
          company: 'GFO IT-Service',
          period: 'Feb 2025 - Aug 2025',
          desc: 'Data Analysis und BI-Lösungen im Gesundheitssektor'
        },
        kvno: {
          title: 'Bedarfsplanung Analyst',
          company: 'Kassenärztliche Vereinigung Nordrhein',
          period: 'Mär 2021 - Jan 2025',
          desc: 'Entwicklung von BI-Dashboards und Datenanalyse-Systemen'
        },
        dci: {
          title: 'Fullstack Developer Training',
          company: 'DCI Digital Career Institute',
          period: 'Okt 2018 - Dez 2019',
          desc: 'Intensive Ausbildung in moderner Web-Entwicklung'
        },
        telespazio: {
          title: 'Controller & BI Analyst',
          company: 'Telespazio S.p.a., Rom',
          period: 'Okt 2004 - Dez 2010',
          desc: 'Financial Controlling und Business Intelligence'
        },
        fastweb: {
          title: 'Projektmanager',
          company: 'Fastweb S.p.a., Rom',
          period: 'Sep 2001 - Sep 2004',
          desc: 'Planung und Entwicklung von Netzwerk-Infrastrukturen'
        }
      }
    },
    projects: {
      title: 'Projekte',
      subtitle: 'Ausgewählte Arbeiten',
      description: 'Eine Auswahl aus Case Studies, Produkt-Experimenten und laufenden Builds — von Data Analytics bis SaaS.',
      filter: {
        all: 'Alle',
        data: 'Data Analytics',
        web: 'Web Development',
        webapps: 'Web Apps',
        it: 'IT Solutions'
      },
      viewDetails: 'Details ansehen',
      challenge: 'Herausforderung',
      solution: 'Lösung',
      results: 'Ergebnisse',
      technologies: 'Technologien',
      ongoing: {
        title: 'Neue Projekte in Entwicklung',
        subtitle: 'Produkte und Side-Projects, an denen ich aktuell arbeite',
        statusLive: 'Live',
        statusInProgressDemo: 'In Entwicklung • Demo online',
        openWebsite: 'Website öffnen',
        openDemo: 'Demo öffnen',
        openRepo: 'Repo öffnen'
      }
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Lassen Sie uns Ihr IT-Projekt besprechen',
      intro: 'Sie haben eine IT-Herausforderung? Egal ob Datenanalyse, Web-Entwicklung oder strategische IT-Beratung – ich freue mich auf Ihre Nachricht.',
      name: 'Name',
      email: 'E-Mail',
      message: 'Nachricht',
      send: 'Nachricht senden',
      sending: 'Wird gesendet...',
      success: 'Nachricht erfolgreich gesendet!',
      error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.'
    },
    footer: {
      rights: 'Alle Rechte vorbehalten',
      location: 'Düsseldorf, Deutschland',
      tagline: 'IT Consultant & Solutions Architect'
    }
  },
  en: {
    nav: {
      about: 'About',
      services: 'Services',
      skills: 'Tech Stack',
      experience: 'Experience',
      projects: 'Projects',
      contact: 'Contact'
    },
    hero: {
      greeting: 'Hi, I am',
      name: 'Patrizio Sbardella',
      title: 'IT Consultant & Solutions Architect',
      subtitle: 'From complex data analytics to web development – I solve IT challenges holistically',
      description: 'Specialized in Data Analytics, Business Intelligence, Web Development, and strategic IT solutions in healthcare and beyond.',
      cta: 'Discuss Project',
      viewWork: 'View Projects'
    },
    about: {
      title: 'About Me',
      subtitle: 'IT Expert with Vision',
      intro: 'As a versatile IT Consultant, I combine technical expertise with strategic thinking. My strength lies in analyzing complex IT challenges and developing tailored solutions.',
      approach: 'Whether data analysis, web development, or IT infrastructure – I bring over 20 years of experience in various IT fields and find the optimal technical solution for every problem.',
      expertise: 'From developing interactive dashboards to programming web applications to strategic IT consulting – my expertise covers the entire spectrum of modern IT solutions.'
    },
    services: {
      title: 'Services',
      subtitle: 'Comprehensive IT Solutions',
      data: {
        title: 'Data Analytics & BI',
        desc: 'Development of BI solutions, interactive dashboards, and data-driven analyses with Power BI, PostgreSQL, Metabase, and Apache Airflow.',
        items: ['Power BI Dashboards', 'Data Warehouse Design', 'ETL Processes', 'Business Intelligence', 'Predictive Analytics', 'Data Storytelling']
      },
      web: {
        title: 'Web Development',
        desc: 'Fullstack development of modern web applications with React, Node.js, Python, and modern frameworks.',
        items: ['React & JavaScript', 'Python/FastAPI', 'Responsive Design', 'CMS (Typo3)', 'REST APIs', 'Database Design']
      },
      consulting: {
        title: 'IT Consulting',
        desc: 'Strategic IT consulting, process optimization, and solution architecture for complex technical challenges.',
        items: ['IT Strategy', 'Process Automation', 'System Integration', 'Technical Leadership', 'Healthcare IT', 'Project Management']
      }
    },
    techStack: {
      title: 'Tech Stack',
      subtitle: 'Technologies & Tools',
      categories: {
        data: 'Data & Analytics',
        web: 'Web Development',
        database: 'Databases',
        tools: 'Tools & Platforms',
        languages: 'Programming Languages'
      }
    },
    experience: {
      title: 'Professional Experience',
      subtitle: 'Over 20 Years of IT Expertise',
      present: 'Present',
      roles: {
        gfo: {
          title: 'Software Consultant',
          company: 'GFO IT-Service',
          period: 'Feb 2025 - Aug 2025',
          desc: 'Data Analysis and BI solutions in healthcare sector'
        },
        kvno: {
          title: 'Needs Planning Analyst',
          company: 'Kassenärztliche Vereinigung Nordrhein',
          period: 'Mar 2021 - Jan 2025',
          desc: 'Development of BI dashboards and data analysis systems'
        },
        dci: {
          title: 'Fullstack Developer Training',
          company: 'DCI Digital Career Institute',
          period: 'Oct 2018 - Dec 2019',
          desc: 'Intensive training in modern web development'
        },
        telespazio: {
          title: 'Controller & BI Analyst',
          company: 'Telespazio S.p.a., Rome',
          period: 'Oct 2004 - Dec 2010',
          desc: 'Financial Controlling and Business Intelligence'
        },
        fastweb: {
          title: 'Project Manager',
          company: 'Fastweb S.p.a., Rome',
          period: 'Sep 2001 - Sep 2004',
          desc: 'Planning and development of network infrastructures'
        }
      }
    },
    projects: {
      title: 'Projects',
      subtitle: 'Selected Works',
      description: 'A curated mix of case studies, product experiments, and ongoing builds — from data analytics to SaaS.',
      filter: {
        all: 'All',
        data: 'Data Analytics',
        web: 'Web Development',
        webapps: 'Web Apps',
        it: 'IT Solutions'
      },
      viewDetails: 'View Details',
      challenge: 'Challenge',
      solution: 'Solution',
      results: 'Results',
      technologies: 'Technologies',
      ongoing: {
        title: 'New Projects in Development',
        subtitle: 'Products and side projects I am currently building',
        statusLive: 'Live',
        statusInProgressDemo: 'In progress • Demo online',
        openWebsite: 'Open website',
        openDemo: 'Open demo',
        openRepo: 'Open repo'
      }
    },
    contact: {
      title: 'Contact',
      subtitle: 'Let\'s Discuss Your IT Project',
      intro: 'Do you have an IT challenge? Whether data analysis, web development, or strategic IT consulting – I look forward to your message.',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully!',
      error: 'Error sending message. Please try again.'
    },
    footer: {
      rights: 'All rights reserved',
      location: 'Düsseldorf, Germany',
      tagline: 'IT Consultant & Solutions Architect'
    }
  }
};
